import moment from "util/momentWrapper";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { getAppConfig } from "../commons/util/appConfigHelper";
import {
  getSessionStorage,
  removeSessionStorage,
  setSessionStorage,
} from "../util/storageUtil";
import config from "../commons/config";
import callAPI from "../commons/callAPI";
import { isLoggedIn } from "../commons/util/helperFunctions";

const FlightContext = React.createContext();

const FlightProvider = (props) => {
  const [cookies, setCookie] = useCookies(["userFlight"]);
  const [flightData, setFlightData] = useState(cookies.userFlight || []);

  useEffect(() => {
    /* Runs when flight object changes */
    const expiryDays = getAppConfig("FLIGHT_COOKIE_EXPIRY_DAYS") || 30; // Default to 30 days if config is not available
    setCookie("userFlight", JSON.stringify(flightData), {
      path: "/",
      maxAge: 86400 * expiryDays,
      domain: getAppConfig("COOKIE_DOMAIN"),
    });
  }, [flightData]);

  function reset() {
    setFlightData([]);
    const expiryDays = getAppConfig("FLIGHT_COOKIE_EXPIRY_DAYS") || 30; // Default to 30 days if config is not available
    setCookie("userFlight", JSON.stringify(flightData), {
      path: "/",
      maxAge: 86400 * expiryDays,
      domain: getAppConfig("COOKIE_DOMAIN"),
    });
  }

  function getConnectingFlight(flightDetails) {
    let connectingFlight = {};
    connectingFlight.UID = flightDetails.uid;
    connectingFlight.flightId = flightDetails.flight_unique_no;
    connectingFlight.baseAirport = flightDetails.org_airport_id;
    connectingFlight.srcDestAirport =
      flightDetails.bound_id === "A"
        ? flightDetails.dest_airport_id
        : flightDetails.orgdest_airport_id;
    connectingFlight.baseAirportName = flightDetails.base_airport_name;
    connectingFlight.srcDestAirportName = flightDetails.srcdest_airport_name;
    connectingFlight.movementType = flightDetails.bound_id;
    connectingFlight.sector = flightDetails.flight_id;
    connectingFlight.scheduleDate = flightDetails.schedule_date;
    connectingFlight.scheduleTime = flightDetails.schedule_hour_id
      ? moment(flightDetails.schedule_hour_id, "YYYY-MM-DD HH:mm:ss").format(
        "HH:mm:ss"
      )
      : "";
    connectingFlight.scheduleDateTime = flightDetails.schedule_hour_id
      ? moment(flightDetails.schedule_hour_id, "YYYY-MM-DD HH:mm:ss").format(
        "YYYYMMDDHHmmss"
      )
      : "";
    connectingFlight.estimatedDateTime = flightDetails.estimated_hour_id
      ? moment(flightDetails.estimated_hour_id, "YYYY-MM-DD HH:mm:ss").format(
        "YYYYMMDDHHmmss"
      )
      : "";
    connectingFlight.baseTerminal =
      flightDetails.baseTerminal &&
        flightDetails.baseTerminal !== undefined &&
        flightDetails.baseTerminal !== null
        ? flightDetails.baseTerminal
        : "";
    connectingFlight.srcDestTerminal =
      flightDetails.srcDestTerminal &&
        flightDetails.srcDestTerminal !== undefined &&
        flightDetails.srcDestTerminal !== null
        ? flightDetails.srcDestTerminal
        : "";
    connectingFlight.airlineId = flightDetails.airline_iata_id;
    connectingFlight.airlineName = flightDetails.airline_name;
    connectingFlight.airlineImg = flightDetails.airline_img;
    return connectingFlight;
  }

  function addFlight(flightDetails, connectingFlightDetails) {
    let flightsArray = [];
    let flightObj = [];
    let reqBody = {};
    if (connectingFlightDetails && connectingFlightDetails.length > 0) {
      let transitFlight = getConnectingFlight(flightDetails);
      flightsArray.push({
        UID: connectingFlightDetails[0].uid,
        flightId: connectingFlightDetails[0].flight_unique_no,
        baseAirport: connectingFlightDetails[0].org_airport_id,
        srcDestAirport:
          connectingFlightDetails[0].bound_id === "A"
            ? connectingFlightDetails[0].dest_airport_id
            : connectingFlightDetails[0].orgdest_airport_id,
        baseAirportName: connectingFlightDetails[0].base_airport_name,
        srcDestAirportName: connectingFlightDetails[0].srcdest_airport_name,
        movementType: connectingFlightDetails[0].bound_id,
        sector: connectingFlightDetails[0].flight_id,
        scheduleDate: connectingFlightDetails[0].schedule_date,
        scheduleTime: connectingFlightDetails[0].schedule_hour_id
          ? moment(
            connectingFlightDetails[0].schedule_hour_id,
            "YYYY-MM-DD HH:mm:ss"
          ).format("HH:mm:ss")
          : "",
        scheduleDateTime: connectingFlightDetails[0].schedule_hour_id
          ? parseInt(
            moment(
              connectingFlightDetails[0].schedule_hour_id,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYYMMDDHHmmss")
          )
          : "",
        estimatedDateTime: connectingFlightDetails[0].estimated_hour_id
          ? parseInt(
            moment(
              connectingFlightDetails[0].estimated_hour_id,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYYMMDDHHmmss")
          )
          : "",
        baseTerminal:
          connectingFlightDetails[0].baseTerminal &&
            connectingFlightDetails[0].baseTerminal !== undefined &&
            connectingFlightDetails[0].baseTerminal !== null
            ? connectingFlightDetails[0].baseTerminal
            : "",
        srcDestTerminal:
          connectingFlightDetails[0].srcDestTerminal &&
            connectingFlightDetails[0].srcDestTerminal !== undefined &&
            connectingFlightDetails[0].srcDestTerminal !== null
            ? connectingFlightDetails[0].srcDestTerminal
            : "",
        airlineId: connectingFlightDetails[0].airline_iata_id,
        airlineName: connectingFlightDetails[0].airline_name,
        airlineImg: connectingFlightDetails[0].airline_img,
        connectingFlight: transitFlight,
      });
    } else {
      flightsArray.push({
        UID: flightDetails.uid || flightDetails[0].UID,
        flightId: flightDetails.flight_unique_no || flightDetails[0].flightId,
        baseAirport: flightDetails.org_airport_id || flightDetails[0].baseAirport,
        srcDestAirport:
          flightDetails.bound_id === "A"
            ? flightDetails.dest_airport_id
            : flightDetails.orgdest_airport_id || flightDetails[0].srcDestAirport,
        baseAirportName: flightDetails.base_airport_name || flightDetails[0].baseAirportName,
        srcDestAirportName: flightDetails.srcdest_airport_name || flightDetails[0].srcDestAirportName,
        movementType: flightDetails.bound_id || flightDetails[0].movementType,
        sector: flightDetails.flight_id || flightDetails[0].sector,
        scheduleDate: flightDetails.schedule_date || flightDetails[0].scheduleDate,
        scheduleTime: flightDetails.schedule_hour_id || flightDetails[0].scheduleTime,
        scheduleDateTime: flightDetails.schedule_hour_id || flightDetails[0].scheduleDateTime,
        estimatedDateTime: flightDetails.estimated_hour_id || flightDetails[0].estimatedDateTime,
        baseTerminal:
          flightDetails.baseTerminal &&
            flightDetails.baseTerminal !== undefined &&
            flightDetails.baseTerminal !== null
            ? flightDetails.baseTerminal
            : flightDetails[0].baseTerminal,
        srcDestTerminal:
          flightDetails.srcDestTerminal &&
            flightDetails.srcDestTerminal !== undefined &&
            flightDetails.srcDestTerminal !== null
            ? flightDetails.srcDestTerminal
            : flightDetails[0].srcDestTerminal,
        airlineId: flightDetails.airline_iata_id || flightDetails[0].airlineId,
        airlineName: flightDetails.airline_name || flightDetails[0].airlineName,
        airlineImg: flightDetails.airline_img || flightDetails[0].airlineImg,
        gateId: flightDetails.gate_id,
        status: flightDetails.flight_status_id || flightDetails[0].status,
        beltId: flightDetails.belt_id,
        departureTimeInLocal: flightDetails.departureTimeInLocal || flightDetails[0].departureTimeInLocal,
        originTimezoneAbbreviation: flightDetails.originTimezoneAbbreviation || flightDetails[0].originTimezoneAbbreviation
      });
    }
    flightData.push(flightsArray[0]);
    flightObj = JSON.parse(JSON.stringify(flightsArray[0]));
    setSessionStorage("flightDetails", flightObj);
    flightObj.scheduleDateTime = flightObj?.scheduleDateTime?.toString();
    flightObj.estimatedDateTime = flightObj?.estimatedDateTime?.toString();
    reqBody.flight = flightObj;
    const expiryDays = getAppConfig("FLIGHT_COOKIE_EXPIRY_DAYS") || 30; // Default to 30 days if config is not available
    setCookie("userFlight", JSON.stringify(flightData), {
      path: "/",
      maxAge: 86400 * expiryDays,
      domain: getAppConfig("COOKIE_DOMAIN"),
    });
    // addFlightToProfile(reqBody);
    return true;
  }

  function removeFlight(uid, dontRemoveMandatoryInfo) {
    if (flightData.length > 0) {
      let filteredFlightArray = flightData.filter((x) => x.UID !== uid);
      setFlightData([...filteredFlightArray]);
      const expiryDays = getAppConfig("FLIGHT_COOKIE_EXPIRY_DAYS") || 30; // Default to 30 days if config is not available
      setCookie("userFlight", JSON.stringify(filteredFlightArray), {
        path: "/",
        maxAge: 86400 * expiryDays,
        domain: getAppConfig("COOKIE_DOMAIN"),
      });
      const fnbStorage = getSessionStorage("productsData");
      if (fnbStorage) {
        delete fnbStorage["flightDetails"];
      }
      setSessionStorage("productsData", fnbStorage);
      if (!dontRemoveMandatoryInfo) {
        removeSessionStorage("mandatoryInfoData");
      }
      // if (isLoggedIn()) {
      //   try {
      //     let apiURL = config.api.addNewFlights.removeFlight;
      //     let apiResponse = await callAPI.delete(
      //       apiURL,
      //       {},
      //       {
      //         UID: uid,
      //       }
      //     );
      //     let regResponse = await apiResponse.json();
      //   } catch (e) {
      //     console.log(e);
      //   }
      // }
    }
  }

  function myFlights() {
    if (flightData.length > 0) {
      let sortedFlightArray = flightData.sort(
        (a, b) =>
          moment(a.estimatedDateTime, "YYYYMMDDHHmmss") -
          moment(b.estimatedDateTime, "YYYYMMDDHHmmss")
      );
      sortedFlightArray = sortedFlightArray.filter((x) =>
        moment(x.estimatedDateTime, "YYYYMMDDHHmmss").isAfter(
          moment(new Date())
        )
      );
      const expiryDays = getAppConfig("FLIGHT_COOKIE_EXPIRY_DAYS") || 30; // Default to 30 days if config is not available
      setCookie("userFlight", JSON.stringify(sortedFlightArray), {
        path: "/",
        maxAge: 86400 * expiryDays,
        domain: getAppConfig("COOKIE_DOMAIN"),
      });
      return sortedFlightArray;
    } else {
      return flightData;
    }
  }

  function getFlightById(id) {
    let allFlightsData = myFlights();
    let currentFlight;
     if (allFlightsData.length === 0) {
      currentFlight = getSessionStorage("flightDetails");
    } else {
    allFlightsData.forEach((flight) => {
      if (flight.flightId === id) {
        currentFlight = flight;
      }
    })
    }

    return currentFlight;
  }

  async function syncFlightsFromUserProfile() {
    let flights = [];
    if (isLoggedIn()) {
      try {
        let apiURL = config.api.addNewFlights.myFlights;
        let apiResponse = await callAPI.get(apiURL);
        let regResponse = await apiResponse.json();
        if (regResponse?.status === 200) {
          if (regResponse?.data?.flights?.length > 0) {
            flights = regResponse?.data?.flights;
          }
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      flights = flightData;
    }
    if (flights.length > 0) {
      flights.forEach((x) => {
        x.scheduleDateTime = parseInt(x?.scheduleDateTime);
        x.estimatedDateTime = parseInt(x?.estimatedDateTime);
      });
      let sortedFlightArray = flights.sort(
        (a, b) =>
          moment(a.estimatedDateTime, "YYYYMMDDHHmmss") -
          moment(b.estimatedDateTime, "YYYYMMDDHHmmss")
      );
      sortedFlightArray = sortedFlightArray.filter((x) =>
        moment(x.estimatedDateTime, "YYYYMMDDHHmmss").isAfter(
          moment(new Date())
        )
      );
      setFlightData([...sortedFlightArray]);
      const expiryDays = getAppConfig("FLIGHT_COOKIE_EXPIRY_DAYS") || 30; // Default to 30 days if config is not available
      setCookie("userFlight", JSON.stringify(sortedFlightArray), {
        path: "/",
        maxAge: 86400 * expiryDays,
        domain: getAppConfig("COOKIE_DOMAIN"),
      });
    } else {
      setFlightData([...flights]);
      const expiryDays = getAppConfig("FLIGHT_COOKIE_EXPIRY_DAYS") || 30; // Default to 30 days if config is not available
      setCookie("userFlight", JSON.stringify(flights), {
        path: "/",
        maxAge: 86400 * expiryDays,
        domain: getAppConfig("COOKIE_DOMAIN"),
      });
    }
    return true;
  }

  async function addFlightToProfile(reqBody) {
    if (isLoggedIn()) {
      try {
        let apiURL = config.api.addNewFlights.addFlight;
        let apiResponse = await callAPI.post(apiURL, reqBody);
        let regResponse = await apiResponse.json();
      } catch (e) {
        console.log(e);
      }
    }
  }

  async function saveFlight() {
    let flightObj = {};
    let reqBody = {};
    if (flightData?.length > 0) {
      flightObj = JSON.parse(JSON.stringify(flightData[0]));
      flightObj.scheduleDateTime = flightObj?.scheduleDateTime?.toString();
      flightObj.estimatedDateTime = flightObj?.estimatedDateTime?.toString();
    }
    reqBody.flight = flightObj;
    addFlightToProfile(reqBody);
  }

  return (
    <FlightContext.Provider
      value={{
        reset,
        addFlight,
        removeFlight,
        myFlights,
        getFlightById,
        syncFlightsFromUserProfile,
        saveFlight,
        flightData,
      }}
    >
      {props.children}
    </FlightContext.Provider>
  );
};

export { FlightContext, FlightProvider };
